import { View, StyleSheet, TouchableOpacity, Image } from 'react-native';
import React, { useEffect, useState } from 'react';
import TypographyDLSBase from '../../typography/TypographyDLS.base';
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Icon from '../../icon/Icon';
import { isMobileView } from '../../stack/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
const ModalContent = ({ onClose, handleConnection, triggerAction, rmData }) => {
    const isRelationshipManagerPresent = rmData?.isRelationshipManagerPresent;
    const isWhatsappGroupPresent = rmData?.isWhatsappGroupPresent;
    const relationshipManagerFullName = rmData?.relationshipManagerFullName;
    const relationshipManagerPhoneNumber = rmData?.relationshipManagerPhoneNumber;
    const businessHours = rmData?.businessHours;
    const profileImageURL = rmData?.profileImageURL;
    const whatsappGroupLink = rmData?.whatsappGroupLink;
    const whatsappGroupName = rmData?.whatsappGroupName;
    const groupName = whatsappGroupName ? whatsappGroupName.length > 24 ? whatsappGroupName.substring(0, 24) + '...' : whatsappGroupName : "";
    const [showPartnerInfo, setShowPartnerInfo] = useState(false);
    const [partnerHelpLineNumber, setPartnerHelpLineNumber] = useState("");
    const [partnerSupportAvailability, setPartnerSupportAvailability] = useState("");
    const handlePartnerInfoModal = () => {
        setShowPartnerInfo(!showPartnerInfo);
    };
    const handleRmConnection = (type, partnerDetail) => {
        if (handleConnection)
            triggerAction({
                ...handleConnection,
                payload: {
                    partnerDetail, type,
                    ...handleConnection.payload
                }
            });
    };
    const getHelpLineDetails = async () => {
        const fetchedConfig = await AsyncStorage.getItem("remoteConfig");
        let configData;
        if (fetchedConfig) {
            configData = JSON.parse(fetchedConfig);
            setPartnerHelpLineNumber(configData?.partner_contact_support_number);
            setPartnerSupportAvailability(configData?.partner_support_availability);
        }
    };
    useEffect(() => {
        getHelpLineDetails();
    }, []);
    const RmModal = () => {
        return (React.createElement(View, { style: styles.content },
            React.createElement(View, null,
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2S, label: "CONTACT RELATIONSHIP MANAGER", color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: styles.details },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { backgroundColor: '#F1F3F5', borderRadius: 1000 } },
                        React.createElement(View, { style: { borderRadius: 1000, justifyContent: 'center', alignItems: 'center' } },
                            React.createElement(Image, { source: { uri: profileImageURL !== null ? profileImageURL : "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Mask+group.png" }, style: { width: 56, height: 56, borderRadius: 1000 } }))),
                    React.createElement(View, { style: { marginLeft: 12, paddingRight: 68, width: '100%' } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B0S, label: relationshipManagerFullName, color: ColorTokens.Grey_Night }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: businessHours, color: ColorTokens.Grey_Charcoal }))),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 18, alignItems: 'center' } },
                    React.createElement(View, null,
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "Contact RM", color: ColorTokens.Grey_Night }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: relationshipManagerPhoneNumber?.slice(0, 5) + ' ' + relationshipManagerPhoneNumber.slice(5), color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('CALL', relationshipManagerPhoneNumber); }, style: { padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_CALL_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('WHATSAPP', relationshipManagerPhoneNumber); }, style: { marginLeft: 12, padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_WHATSAPP_DLS, size: IconSizeTokens.XXXL })))),
                isWhatsappGroupPresent && React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 18 } },
                    React.createElement(View, null,
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "Message on group", color: ColorTokens.Grey_Night }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: groupName, color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, null,
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('GROUP_WHATSAPP', whatsappGroupLink); }, style: { padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_WHATSAPP_DLS, size: IconSizeTokens.XXXL }))))),
            React.createElement(View, { style: { marginTop: 16, padding: 12, borderWidth: 1, borderColor: '#E4E7EC', borderRadius: 8 } },
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                    React.createElement(View, null,
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Unable to contact RM? ", color: ColorTokens.Grey_Night }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1B, label: "Contact support team", color: ColorTokens.Grey_Night })),
                    React.createElement(TouchableOpacity, { onPress: handlePartnerInfoModal, style: { justifyContent: 'center' } },
                        React.createElement(Icon, { name: showPartnerInfo ? IconTokens.SYSTEM_CHEVRON_UP_DLS : IconTokens.SYSTEM_CHEVRON_DOWN_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal }))),
                showPartnerInfo && React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16, alignItems: 'center' } },
                    React.createElement(View, null,
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "Partner’s helpline", color: ColorTokens.Grey_Night }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: partnerHelpLineNumber?.slice(0, 5) + ' ' + partnerHelpLineNumber.slice(5), color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('CALL', partnerHelpLineNumber); }, style: { padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_CALL_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('WHATSAPP', partnerHelpLineNumber); }, style: { marginLeft: 12, padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_WHATSAPP_DLS, size: IconSizeTokens.XXXL })))),
                showPartnerInfo && React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: partnerSupportAvailability, color: ColorTokens.Grey_Charcoal })))));
    };
    const DefaultModal = () => {
        return (React.createElement(View, { style: styles.defaultModalContainer },
            React.createElement(View, { style: styles.defaultModalContentContainer },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { backgroundColor: '#F3F5FC', borderRadius: 8, width: 40, height: 40, marginRight: 7, alignItems: 'center', justifyContent: 'center' } },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_SUPPORT_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
                    React.createElement(View, { style: { alignItems: 'center', justifyContent: 'center' } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B0S, label: "Contact Support", color: ColorTokens.Grey_Night }))),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 } },
                    React.createElement(View, { style: {} },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "Partner’s helpline", color: ColorTokens.Grey_Night }),
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: partnerHelpLineNumber?.slice(0, 5) + ' ' + partnerHelpLineNumber.slice(5), color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('CALL', partnerHelpLineNumber); }, style: { padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_CALL_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Primary_100 })),
                        React.createElement(TouchableOpacity, { onPress: () => { handleRmConnection('WHATSAPP', partnerHelpLineNumber); }, style: { marginLeft: 12, padding: 8, borderRadius: 8, backgroundColor: '#F3F5FC' } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_WHATSAPP_DLS, size: IconSizeTokens.XXXL })))),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(View, { style: {} },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: partnerSupportAvailability, color: ColorTokens.Grey_Charcoal }))))));
    };
    return (React.createElement(View, { style: styles.container },
        isRelationshipManagerPresent && React.createElement(RmModal, null),
        !isRelationshipManagerPresent && React.createElement(DefaultModal, null),
        React.createElement(View, { style: styles.crossIconContentContainer },
            React.createElement(TouchableOpacity, { style: styles.crossIconContent, onPress: onClose },
                React.createElement(Icon, { name: IconTokens.SYSTEM_CANCEL_DLS, size: IconSizeTokens.XXXL, color: isMobileView() ? ColorTokens.Grey_Charcoal : ColorTokens.White })))));
};
const styles = StyleSheet.create({
    container: {
        marginRight: 40,
        marginBottom: 40,
    },
    content: {
        borderColor: '#E4E7EC',
        borderWidth: 1,
        borderRadius: 8,
        padding: 16,
        backgroundColor: '#FFFFFF',
        width: 302,
    },
    crossIconContentContainer: {
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    crossIconContent: {
        marginTop: 8,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        borderRadius: 1000,
        backgroundColor: isMobileView() ? '#fff' : '#1434CB',
        width: 56,
        height: 56,
    },
    details: {
        marginTop: 8,
        padding: 12,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#E4E7EC',
    },
    defaultModalContainer: {
        borderColor: '#E4E7EC',
        borderWidth: 1,
        borderRadius: 8,
        padding: 16,
        backgroundColor: '#FFFFFF',
        width: 302,
    },
    defaultModalContentContainer: {
        borderColor: '#E4E7EC',
        borderWidth: 1,
        borderRadius: 8,
        padding: 12,
        backgroundColor: '#FFFFFF',
    },
});
export default ModalContent;
